import { environmentConfigItems, getEnvironment } from "./all-environments-config.model";
import { EnvironmentNames } from "./models/environment-names.enum";

export const environment = {
  production: true,
  baseTitle: 'Aviator Online',

  environment: getEnvironment(EnvironmentNames.prod),
  altEnvironment: getEnvironment(EnvironmentNames.stage),

  //environmentMessage: '',
  // apiRoot: "https://aviator-online-prod-api.azurewebsites.net/api/v1",
  // //cdnRoot: "https://aviator-online-prod.azureedge.net/api/v1",
  // // Move to Bunny.net CDN
  // cdnRoot: "https://aviator-online-prod-api.b-cdn.net/api/v1",
  // useCDN: true,
  tenantKey: '16970b66-9788-4e12-aeb3-36bda56bd32f',

  //stripePublicKey: "pk_test_51PtXdVRvgfUzg9zpJzvEDuaMoSMHAhz4CRU3RMTCzfN89Rl44UYlPyk8gfzp9X6hsRkCEjturKdlpHvrDOXxrgSu00fPYTuMq3",
  allowConfiguration: true,
  enableConsoleLogging: false,
  disableLocalStorageCaching: true,

  googleAnalyticsTrackingToken: null,
  showContactUs: true,
  contactUsEmail: 'support@pilexos.com',
  disabledUserInactvityTimeout: false,

};
